<template>
  <div class="container">
    <auto-table
      :DataList="DataList"
      :option="Option"
      :total="Total"
      @changePage="getList"
    >
      <template #name="{ row }">
        <div>
          {{ row.mechanism.mechanism_name }}
        </div>
      </template>
      <template #handle="{ row }">
        <el-button size="small" type="danger" @click="unbind(row)"
          >解绑</el-button
        >
      </template>
    </auto-table>

    <el-button type="primary" @click="newBind">绑定新商场</el-button>
    <div v-loading="loading">
      <el-form v-if="formShow">
        <el-form-item label="搜索商场" v-if="mode == 'add'">
          <div>
            <el-input v-model="name" placeholder="名称"></el-input>
            <el-button type="success" @click="getMecList(1)">搜索</el-button>
          </div>
          <auto-table
            :DataList="mecDataList"
            :option="mecOption"
            :total="mecTotal"
            @changePage="getMecList"
          >
            <template #handle="{ row }">
              <el-button size="small" type="danger" @click="addBind(row)"
                >绑定</el-button
              >
            </template>
          </auto-table>
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>

<script>
import { ratioTypeMap } from "./components/type.js";

export default {
  data() {
    return {
      amountShow: false,
      investForm: {
        coop_amount: "",
        self_amount: "",
      },
      name:'',
      ratioTypeMap: ratioTypeMap,
      mechanism: {},
      form: {},
      coop_id: "",
      DataList: [],
      ratios: [],
      Option: [
        { name: "机构名称", value: "name", type: "custom" },
        { name: "投资金额", value: "mechanism.init_amount" },
        { name: "操作", value: "handle", type: "custom", width: "300px" },
      ],
      Total: 0,
      mecDataList: [],
      mecOption: [
        { name: "机构名称", value: "mechanism_name" },
        { name: "城市", value: "city" },
        { name: "地址", value: "mechanism_addr" },
        { name: "操作", value: "handle", type: "custom", width: "300px" },
      ],
      mecTotal: 0,
      formShow: false,
      loading: false,
      current: {},
      mode: "add",
      row: {},
    };
  },

  mounted() {
    this.coop_id = this.$route.query.id;
    this.getList(1);
  },

  methods: {
    //绑定
    newBind() {
      this.formShow = true;
      this.mechanism = {};
      this.current = {};
      this.mode = "add";
    },
    changeMec(v) {
      this.mechanism = v;
    },
    unbind(row) {
      this.$confirm("确定要解绑门店吗，解绑后将不再获得门店分成").then(() => {
        let data = {
          id: row.id,
          mechanism_id: row.mechanism.id,
        };
        this.$post("/user/coopMechanismRelative/unbind", data).then((res) => {
          this.getList(1);
        });
      });
    },
    openUpdate(row) {
      if (this.loading) {
        return;
      }
      this.mode = "update";
      this.current = row;
      this.loading = true;
      this.mechanism = row.mechanism;
    },
    addBind(row) {
      this.$axios({
        url: "/user/coopMechanismRelative/insert",
        data: {
          coop_id: this.coop_id,
          mechanism_id: row.id,
        },
        method: "post",
      }).then((res) => {
        this.formShow = false;
        this.getList(1);
      });
    },
    getList(v) {
      let page = v || 1;
      this.$axios({
        url: "/user/coopMechanismRelative/queryManagerListPage",
        params: {
          currentPage: page,
          pageSize: 10,
          coop_id: this.coop_id,
        },
      }).then((res) => {
        this.DataList = res.data.data.rows;
        this.Total = res.data.data.total;
      });
    },
    getMecList(v) {
      let page = v || 1;
      this.$axios({
        url: "/user/mastermechanism/queryManagerListPage",
        params: {
          currentPage: page,
          pageSize: 10,
          type: "mall",
          status: 2,
          mechanism_name: this.name || null
        },
      }).then((res) => {
        this.mecDataList = res.data.data.rows;
        this.mecTotal = res.data.data.total;
      });
    },
  },
};
</script>

<style lang="less" scoped>
.mechanism {
  display: flex;
  padding: 20px;
  background-color: #eee;
  width: fit-content;
  border-radius: 10px;
  margin: 20px 0;
}
.m-logo {
  width: 80px;
  height: 80px;
}
.m-info {
  margin-left: 10px;
  line-height: 1.5;
}
.m-title {
  font-size: 16px;
  font-weight: 600;
}
.m-add {
  font-size: 14px;
}
</style>